<div (click)="this.dialogRef.close();" class="d-flex flex-col">
    <h2 class="cdk-visually-hidden" mat-dialog-title>Media viewer</h2>
    <div>
        <div class="flex-row justify-content-end">
            <div class="float-end">
                <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();"
                        aria-label="Close window"
                        class="mat-dialog-close"
                        mat-dialog-close
                        mat-mini-fab
                        matTooltip="Close Window">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        @if (currentMedia) {
            <div>
                <app-media-display [file]="currentMedia"></app-media-display>
            </div>
        }
        @if (!currentMedia) {
            <div class="centerLoading">
                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
            </div>
        }
    </div>
</div>
